export const LOCATION_ID = 'LocationID';
export const STORE_NAME = 'StoreName';
export const STORE_NUMBER = 'StoreNumber';
export const CHAIN = 'Chain';
export const ADDRESS = 'Address';
export const CITY = 'City';
export const STATE = 'State';
export const PROVINCE = 'Province';
export const GUID = 'GUID';
export const POSTAL_CODE = 'PostalCode';
export const PHONE_NUMBER = 'PhoneNumber';
export const LONGITUDE = 'Longitude';
export const LATITUDE = 'Latitude';
export const TIMEZONE = 'Timezone';
export const UTC = 'UTC';
export const LIST = 'List';
export const GRID = 'Grid';
export const CUSTOM = 'Custom';
export const DROPDOWN_THRESHOLD = 400;
export const NULL_STRING = 'null';
export const EMAIL = 'email';
export const INVALID = 'invalid';
export const MAP = 'map';
export const BG_TYPES = {
    ERROR: 'bg-danger',
    INFO: 'bg-info',
    SUCCESS: 'bg-success',
    WARNING: 'bg-warning',
};

// this is used in locations-hub to denote custom fields from the API
// as it stands this should be migrated back, but some shared code uses it
// see UPN-9100 for more details
export const CF_UNDERSCORE = 'cf_';
export const MPLAN_NAME = 'mPlan Name';
export const MPLAN_QUESTION = 'mPlan Question';

/* eslint-disable max-len */
export const NUMBER_WORDS = {
    en: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty', 'twenty-one', 'twenty-two', 'twenty-three', 'twenty-four', 'twenty-five', 'twenty-six', 'twenty-seven', 'twenty-eight', 'twenty-nine', 'thirty', 'thirty-one', 'thirty-two', 'thirty-three', 'thirty-four', 'thirty-five', 'thirty-six', 'thirty-seven', 'thirty-eight', 'thirty-nine', 'forty', 'forty-one', 'forty-two', 'forty-three', 'forty-four', 'forty-five', 'forty-six', 'forty-seven', 'forty-eight', 'forty-nine', 'fifty', 'fifty-one', 'fifty-two', 'fifty-three', 'fifty-four', 'fifty-five', 'fifty-six', 'fifty-seven', 'fifty-eight', 'fifty-nine', 'sixty', 'sixty-one', 'sixty-two', 'sixty-three', 'sixty-four', 'sixty-five', 'sixty-six', 'sixty-seven', 'sixty-eight', 'sixty-nine', 'seventy', 'seventy-one', 'seventy-two', 'seventy-three', 'seventy-four', 'seventy-five', 'seventy-six', 'seventy-seven', 'seventy-eight', 'seventy-nine', 'eighty', 'eighty-one', 'eighty-two', 'eighty-three', 'eighty-four', 'eighty-five', 'eighty-six', 'eighty-seven', 'eighty-eight', 'eighty-nine', 'ninety', 'ninety-one', 'ninety-two', 'ninety-three', 'ninety-four', 'ninety-five', 'ninety-six', 'ninety-seven', 'ninety-eight', 'ninety-nine', 'one-hundred'],
    fr: ['zéro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf', 'vingt', 'vingt et un', 'vingt-deux', 'vingt-trois', 'vingt-quatre', 'vingt-cinq', 'vingt-six', 'vingt-sept', 'vingt-huit', 'vingt-neuf', 'trente', 'Trente et un', 'Trente-deux', 'Trente-trois', 'Trente-quatre', 'Trente-cinq', 'Trente-six', 'Trente-sept', 'Trente-huit', 'Trente-neuf', 'quarante', 'quarante et un', 'quarante-deux', 'quarante-trois', 'quarante-quatre', 'quarante-cinq', 'quarante-six', 'quarante-sept', 'quarante-huit', 'quarante-neuf', 'cinquante', 'cinquante et un', 'cinquante-deux', 'cinquante-trois', 'cinquante-quatre', 'cinquante-cinq', 'cinquante-six', 'cinquante-sept', 'cinquante-huit', 'cinquante-neuf', 'soixante', 'soixante et un', 'soixante-deux', 'soixante-trois', 'soixante-quatre', 'soixante-cinq', 'soixante-six', 'soixante-sept', 'soixante-huit', 'soixante-neuf', 'soixante-dix', 'soixante-et-onze', 'soixante-douze', 'soixante-treize', 'soixante-quatorze', 'soixante-quinze', 'soixante-seize', 'soixante-dix-sept', 'soixante-dix-huit', 'soixante-dix-neuf', 'quatre-vingts', 'quatre-vingt-un', 'quatre-vingt-deux', 'quatre-vingt-trois', 'quatre-vingt-quatre', 'quatre-vingt-cinq', 'quatre-vingt-six', 'quatre-vingt-sept', 'quatre-vingt-huit', 'quatre-vingt-neuf', 'quatre-vingt-dix', 'quatre-vingt-onze', 'quatre-vingt-douze', 'quatre-vingt-treize', 'quatre-vingt-quatorze', 'quatre-vingt-quinze', 'quatre-vingt-seize', 'quatre-vingt-dix-sept', 'quatre-vingt-dix-huit', 'quatre-vingt-dix-neuf', 'cent'],
};

/* eslint-enable max-len */
export const DAYS_OF_WEEK = {
    en: [
        {
            singleLetter: 'S',
            twoLetter: 'Su',
            abbr: 'Sun',
            full: 'Sunday',
            numberValue: 0,
        },
        {
            singleLetter: 'M',
            twoLetter: 'Mo',
            abbr: 'Mon',
            full: 'Monday',
            numberValue: 1,
        },
        {
            singleLetter: 'T',
            twoLetter: 'Tu',
            abbr: 'Tues',
            full: 'Tuesday',
            numberValue: 2,
        },
        {
            singleLetter: 'W',
            twoLetter: 'We',
            abbr: 'Wed',
            full: 'Wednesday',
            numberValue: 3,
        },
        {
            singleLetter: 'T',
            twoLetter: 'Th',
            abbr: 'Thur',
            full: 'Thursday',
            numberValue: 4,
        },
        {
            singleLetter: 'F',
            twoLetter: 'Fr',
            abbr: 'Fri',
            full: 'Friday',
            numberValue: 5,
        },
        {
            singleLetter: 'S',
            twoLetter: 'Sa',
            abbr: 'Sat',
            full: 'Saturday',
            numberValue: 6,
        },
    ],
    fr: [
        {
            singleLetter: 'l',
            twoLetter: 'lu',
            abbr: 'lun',
            full: 'lundi',
            numberValue: 1,
        },
        {
            singleLetter: 'm',
            twoLetter: 'ma',
            abbr: 'mar',
            full: 'mardi',
            numberValue: 2,
        },
        {
            singleLetter: 'm',
            twoLetter: 'me',
            abbr: 'mer',
            full: 'mercredi',
            numberValue: 3,
        },
        {
            singleLetter: 'j',
            twoLetter: 'je',
            abbr: 'jeu',
            full: 'jeudi',
            numberValue: 4,
        },
        {
            singleLetter: 'v',
            twoLetter: 've',
            abbr: 'ven',
            full: 'vendredi',
            numberValue: 5,
        },
        {
            singleLetter: 's',
            twoLetter: 'sa',
            abbr: 'sam',
            full: 'samedi',
            numberValue: 6,
        },
        {
            singleLetter: 'd',
            twoLetter: 'di',
            abbr: 'dim',
            full: 'dimanche',
            numberValue: 0,
        },
    ],
};

// for future use/needs
export const CURRENCY_FORMAT = {
    en_US: '$',
    fr_FR: '€',
    fr_CA: '',
    en_UK: '£',
};

export const MAX_LENGTH_DEFAULT = 255;
export const MAX_LENGTH_EMAIL = 254;
export const MIN_LENGTH_EMAIL = 4;
export const MAX_LENGTH_PHONE_NUMBER = 20;
export const MAX_LENGTH_ADDRESS = 100;
export const PATTERN_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PATTERN_PHONE_NUMBER = /^(\d|x| |\+|-|\(|\)){0,20}$/;
